import { render, staticRenderFns } from "./HistoryActivity.vue?vue&type=template&id=4f863b9a&scoped=true"
import script from "./HistoryActivity.vue?vue&type=script&lang=js"
export * from "./HistoryActivity.vue?vue&type=script&lang=js"
import style0 from "./HistoryActivity.vue?vue&type=style&index=0&id=4f863b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f863b9a",
  null
  
)

export default component.exports